import React from "react";
import Form from "react-bootstrap/Form";
import { useEventsContext } from "../EventsContext/EventsContext";
import "./EventFilterForm.scss";

const EventFilterForm = () => {
  const { filters, setFilters, FILTER_TYPES } = useEventsContext();
  return (
    <>
      <div className="filter-container">
        <div className="row">
          <h4>Event Status</h4>
        </div>
        <div className="row">
          <div className="col-lg-10">
            <Form.Select
              className="form-control"
              value={filters.eventStatus}
              onChange={(e) => {
                let newFilters = { ...filters };
                newFilters["eventStatus"] = e.target.value.toString();
                setFilters(newFilters);
              }}
            >
              {FILTER_TYPES.EVENT_STATUS &&
                FILTER_TYPES.EVENT_STATUS.map((status) => {
                  return (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  );
                })}
            </Form.Select>
          </div>
        </div>
        <div className="row">
          <h4>Streams</h4>
        </div>
        <div className="row">
          <div className="col-lg-10">
            <Form.Select
              className="form-control"
              value={filters.stream}
              onChange={(e) => {
                let newFilters = { ...filters };
                newFilters["stream"] = e.target.value.toString();
                setFilters(newFilters);
              }}
            >
              {FILTER_TYPES.STREAM &&
                FILTER_TYPES.STREAM.map((s) => {
                  return (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  );
                })}
            </Form.Select>
          </div>
        </div>
        <div className="row">
          <h4>Age Category</h4>
        </div>
        <div className="row">
          <div className="col-lg-10">
            <Form.Select
              className="form-control"
              value={filters.ageCategory}
              onChange={(e) => {
                let newFilters = { ...filters };
                newFilters["ageCategory"] = e.target.value.toString();
                setFilters(newFilters);
              }}
            >
              {FILTER_TYPES.AGE_CATEGORY &&
                FILTER_TYPES.AGE_CATEGORY.map((s) => {
                  return (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  );
                })}
            </Form.Select>
          </div>
        </div>
      </div>
    </>
  );
};
export default EventFilterForm;
